export enum FileSourceType {
  DOC = 'DOC',
}

export const ACCEPTED_FILE_EXTENSIONS = [
  'jpg',
  'jpeg',
  'png',
  'pdf',
  'doc',
  'docx',
  'xls',
  'xlsx',
];

export const MAX_FILE_SIZE_IN_MB = 25;
export const UPLOAD_DOCUMENT = 'Upload documents';
export const MAX_FILE_UPLOAD_COUNT = 20;

export const DOCUMENT_UPLOAD_MESSAGES = {
  unsupportedTypeSingle: (fileName: string) =>
    `${fileName} is not a supported file type (PDF, JPG, PNG, or Microsoft Office)`,
  unsupportedTypeMultiple: (fileNames: string[]) =>
    `${fileNames.join(', ')} are not supported file types (PDF, JPG, PNG, or Microsoft Office)`,

  tooLargeSingle: (fileName: string) =>
    `${fileName} exceeds the maximum file size (25 MB)`,
  tooLargeMultiple: (fileNames: string[]) =>
    `${fileNames.join(', ')} exceed the maximum file size (25 MB)`,

  tooManyFiles: (maxCount: number) =>
    `Please upload no more than ${maxCount} files at a time.`,
};

export const DOCUMENT_TABLE_EMPTY_STATE =
  'No documents have been uploaded for this patient';
export const NO_RESULTS_WITH_FILTERS_VIEW =
  'No documents match your current criteria. Try removing filters or searching for a different keyword.';

export const NO_RESULTS_FOUND = 'No results found';
export const VOID_REASON_WRONG_PATIENT_CHART = 'WRONG_PATIENT_CHART';
export const VOID_DOCUMENT_BUTTON_TEXT = 'Void document';
export const CONFIRM_DELETION_BUTTON_TEXT = 'Confirm deletion';
export const PHI_EXPOSURE_WARNING_MESSAGE =
  'To avoid patient PHI exposure, this file will be permanently deleted from all databases.';
export const DROPZONE_OVERLAY_TEXT = 'Drop files here to upload to Documents';
export const DROPZONE_SUPPORTED_FILE_TYPES_TEXT =
  'Supported file types: PDF, JPG, PNG, Microsoft Office';

export const INVALID_FILE_NAME_MESSAGE =
  "File name can only contain letters, numbers, spaces, periods ' . ', dashes ' - ', underscore ' _ ' and parentheses '( )'";

export const PATIENT_DOCUMENT_FILE_FORMAT_FILTER_OPTIONS = [
  { label: 'Image', value: 'png,jpg,jpeg' },
  { label: 'PDF', value: 'pdf' },
  { label: 'Word', value: 'docx,doc' },
  { label: 'Excel', value: 'xlsx,xls' },
];
export const UPLOAD_DATE_RANGE_OPTIONS = {
  LAST_7_DAYS: 'last_7_days',
  LAST_30_DAYS: 'last_30_days',
  THIS_YEAR: 'this_year',
};

export const PATIENT_DOCUMENT_UPLOAD_DATE_FILTER_OPTIONS = [
  { label: 'Last 7 days', value: UPLOAD_DATE_RANGE_OPTIONS.LAST_7_DAYS },
  { label: 'Last 30 days', value: UPLOAD_DATE_RANGE_OPTIONS.LAST_30_DAYS },
  { label: 'This year', value: UPLOAD_DATE_RANGE_OPTIONS.THIS_YEAR },
];

export const DATE_RANGE_OPTION = {
  label: 'Date range',
  searchData: 'date range',
  value: 'date_range',
};

export const DOC_FILE_SOURCE = {
  NOTE: 'Note',
};

export const DUPLICATE_FILE_NAME_ERROR_MESSAGE =
  'A file with that name already exists, please choose another name.';
